import * as React from 'react';
import style from './IndexPage.scss';
import { getName } from '../../../../utils/treeVisitors/helpers';
import classnames from 'classnames';
import { isArticlesCategory } from '../../../../utils/typeUtils';
import { TopLevelCategoryIndexPage } from './TopLevelCategoryIndexPage';
import { ApiReferenceCategoryIndexPage } from './ApiReferenceCategoryIndexPage';

interface IndexPageProps {
  node: any;
  isOpened: boolean;
  onShowMoreClick: () => void;
  prefix: string;
  depth: number;
}

export const IndexPage = React.memo<IndexPageProps>(
  ({ node, isOpened, onShowMoreClick, prefix, depth }) => {
    return (
      <article
        className={classnames({
          [style.indexPage]: true,
          [style.open]: isOpened,
        })}
        data-hook="index-page-wrapper"
      >
        {isArticlesCategory(node) ? (
          <TopLevelCategoryIndexPage
            categoryName={getName(node.data)}
            prefix={prefix}
          />
        ) : (
          <ApiReferenceCategoryIndexPage
            node={node}
            isOpened={isOpened}
            onShowMoreClick={onShowMoreClick}
            prefix={prefix}
            depth={depth}
          />
        )}
      </article>
    );
  },
  (prevProps, nextProps) =>
    prevProps.isOpened === nextProps.isOpened &&
    prevProps.node === nextProps.node,
);
